export const aboutLinksEN = [
  { href: '/#about', label: 'Our Story' },
  { href: '/clinical-team/', label: 'Our Clinical Team' },
  { href: '/in-the-news/', label: 'In the News' },
  { href: '/pricing-insurance/', label: 'Pricing & Insurance' },
  { href: '/faq/', label: 'FAQ' },
  { href: '/contact/', label: 'Contact Us' },
]

export const partnerShipLinksEN = [
  { href: '/health-systems/', label: 'For Health Systems' },
  { href: '/employers/', label: 'For Employers' },
  { href: '/providers/', label: 'For Providers' },
  { href: '/clinicians/', label: 'Clinical Library' },
]

export const aboutLinksES = [
  { href: '/es/#about', label: 'Nuestra Historia' },
  { href: '/es/clinical-team/', label: 'Nuestro equipo clínico' },
  { href: '/es/in-the-news/', label: 'En la prensa' },
  { href: '/es/pricing-insurance/', label: 'Precios y Seguros' },
  { href: '/es/faq/', label: 'Preguntas Frecuentes' },
  { href: '/es/contact/', label: 'Contáctenos' },
]

// NOTE: no Clinical Library entry here on purpose — the hub exists only in
// en-us, so /es/clinicians/ 404s. Add it when an es-es clinician_index_page
// document is created.
export const partnerShipLinksES = [
  { href: '/es/health-systems/', label: 'Para Sistemas de Salud' },
  { href: '/es/employers/', label: 'Para Empresas' },
  { href: '/es/providers/', label: 'Para Profesionales de la Salud' },
]

export const individualsLinkEN = {
  href: '/individuals/',
  label: 'For individuals',
}

export const individualsLinkES = {
  href: '/es/individuals/',
  label: 'Para personas',
}

export const signInLinkEN = {
  href: 'https://app.gabbi.com/login',
  label: 'Sign in',
}

export const signInLinkES = {
  href: 'https://app.gabbi.com/es/login',
  label: 'Acceder',
}

export const learnYourRiskLinkEN = {
  href: 'https://app.gabbi.com/intro-questions/interception',
  label: 'Learn your risk',
}

export const learnYourRiskLinkES = {
  href: 'https://app.gabbi.com/es/intro-questions/interception',
  label: 'Evalúe su riesgo',
}

export const partnerWithUsLinkEN = {
  href: 'https://share.hsforms.com/2TWXuPUcTQiGU1hEtw9nNUAnkzhj?tid=3728a85c-a485-48d2-938b-8f004b7be786',
  label: 'Partner with us',
}

export const partnerWithUsLinkES = {
  href: 'https://share.hsforms.com/2TWXuPUcTQiGU1hEtw9nNUAnkzhj?tid=3728a85c-a485-48d2-938b-8f004b7be786',
  label: 'Asóciese',
}

export const privacyLinkEN = {
  href: '/privacy',
  label: 'Privacy',
}

export const privacyLinkES = {
  href: '/es/privacy',
  label: 'Privacidad',
}

export const termsLinkEN = {
  href: '/terms',
  label: 'Terms',
}

export const termsLinkES = {
  href: '/es/terms',
  label: 'Términos',
}

export const hipaaLinkEN = {
  href: '/npp',
  label: 'HIPAA Notice of Privacy Practices',
}

export const hipaaLinkES = {
  href: '/es/npp',
  label: 'Aviso de prácticas de privacidad de HIPAA',
}

// English only: there is no es-es clinician_index_page, so /es/clinicians/
// 404s. The footer omits this link entirely for other locales.
export const clinicalLibraryLinkEN = {
  href: '/clinicians/',
  label: 'Clinical Library',
}

export const pressLinkEN = { href: '/in-the-news/', label: 'Press' }

export const pressLinkES = { href: '/es/in-the-news/', label: 'Prensa' }

export const teamLinkEN = { href: '/team/', label: 'Team and Careers' }

export const teamLinkES = { href: '/team/', label: 'Equipo y Carreras' }

export const cookiePrivacyLinkEN = {
  href: '/privacy',
  label: 'here',
}

export const cookiePrivacyLinkES = {
  href: '/es/privacy',
  label: 'aquí',
}
